import { useAppSelector } from 'store/store';
import { ROLE_SUPER_ADMIN } from 'shared/permissions/roles';

export function IsSuperAdmin({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups && groups.includes(ROLE_SUPER_ADMIN)) return children;
}

export function IsSuperAdminGuard(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups && groups.includes(ROLE_SUPER_ADMIN);
}
